import React from 'react';
import styles from './holidayTypeSelector.module.scss';
import HolidaySelect from './holidayType';
export const HolidayTypeSelector = ({ onSelect, holidayType = '', handleGTMFilterChange, }) => {
    const innerOnChange = (value, name) => {
        onSelect(value);
        handleGTMFilterChange('holiday type', name || 'any');
    };
    return (<div className={styles.holidaySelector}>
      <HolidaySelect value={holidayType} onChange={innerOnChange}/>
    </div>);
};
